export default "__VITE_ASSET__zM2v$LGh__"